export const formats = [
    {
        "name": 'Articles (full text)',
        "slug": 'articles'
    },
    {
        "name": 'Audiobooks',
        "slug": 'audiobooks'
    },
    {
        "name": 'Ebooks',
        "slug": 'ebooks'
    },
    {
        "name": 'Encyclopedias & Dictionaries',
        "slug": 'encyclopedias'
    },
    {
        "name": 'Images',
        "slug": 'images'
    },
    {
        "name": 'Index (no full text)',
        "slug": 'index'
    },
    {
        "name": 'News',
        "slug": 'news'
    },
    {
        "name": 'Videos',
        "slug": 'videos'
    },
]